export const VDT = {
  messages: {
    required: '这是必填字段',
    email: '请输入有效的电子邮件地址',
    url: '请输入有效的网址',
    minvalue: '最小值为多少',
    isArr: '是否是数组',
    maxvalue: '最大值为我传入的',
    minlength: '输入字数过短',
    maxlength: '输入字数过长',
    date: '请输入有效的日期',
    dateISO: '请输入有效的日期 (YYYY-MM-DD)',
    number: '请输入有效的数字',
    elevenPhone: '请输入11位的电话号码',
    digits: '只能输入数字',
    floatDigit: '输入代小数点的数字',
    creditCard: '请输入有效的信用卡号码',
    equalTo: '你的输入不相同',
    extension: '请输入有效的后缀',
    mPhone: '请输入正确的手机号格式',
    tPhone: '请输入正确的电话格式',
    fax: '请输入正确的传真',
    postal: '请输入正确的邮编格式',
    regEn: '请输入有效字符',
    regCn: '请输入有效字符',
    equalLength: '字符长度相等',
    seNumber: '校验数字字母',
    rangeLength: ''
  },
  required: (value, param) => {
    return value !== undefined ? value.toString().length > 0 : false
  },
  email: value => {
    return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
      value
    )
  },
  seNumber: value => {
    return /[0-9a-zA-Z]+/.test(value)
  },
  url: value => {
    return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
      value
    )
  },
  minvalue: (value, param) => {
    return value >= param
  },
  maxvalue: (value, param) => {
    return value < param
  },
  minlength: (value, param) => {
    return value.length >= param
  },
  maxlength: (value, param) => {
    return value.length <= param
  },
  equalLength: (value, param) => {
    if (value) {
      value = value.toString()
      return value.length === param
    }
  },
  date: function(value) {
    return !/Invalid|NaN/.test(new Date(value).toString())
  },
  dateISO: function(value) {
    return /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(
      value
    )
  },
  number: function(value) {
    return /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value)
  },
  digits: function(value) {
    return /^\d+$/.test(value)
  },
  floatDigit: function(value) {
    // 有小数点不限制后面
    // return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(value);
    // 保留小数点后两位
    return /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/g.test(value)
  },
  isArr: function(o) {
    return Object.prototype.toString.call(o) === '[object Array]'
  },
  rangeLength: function(value, param) {
    const length = Array.isArray(value) ? value.length : this.getLength(value)
    return length >= param[0] && length <= param[1]
  },
  min: function(value, param) {
    return value >= param
  },
  max: function(value, param) {
    return value <= param
  },
  range: function(value, param) {
    return value >= param[0] && value <= param[1]
  },
  equalTo: function(value, param) {
    return value === param
  },
  mPhone: function(value) {
    return /^1[3|4|5|8][0-9]\d{4,8}$/.test(value)
  },
  tPhone: function(value) {
    return /^[+]{0,1}(\d){1,3}[ ]?([-]?((\d)|[ ]){1,12})+$/.test(value)
  },
  elevenPhone: function(value) {
    return /^1\d{10}$/.test(value)
  },
  fax: function(value) {
    return /^(\d{3,4}-)?\d{7,8}$/.test(value)
  },
  postal: function(value) {
    return /^[a-zA-Z0-9 ]{3,12}$/g.test(value)
  },
  regEn: function(value) {
    return !/[`~!@#$%^&*()+--=<>?:"{},.\/;'[\]]/im.test(value)
  },
  regCn: function(value) {
    return !/[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im.test(value)
  }
}

export const VDATA = (value, config) => {
  for (const fun in config) {
    if (
      typeof VDT[fun] === 'function' &&
        !(config[fun].param === undefined
          ? VDT[fun](value)
          : VDT[fun](value, config[fun].param))
    ) {
      if (typeof config[fun] === 'object') {
        return {
          msg: config[fun].msg ? config[fun].msg : VDT[fun],
          result: false
        }
      } else {
        return {
          msg: typeof config[fun] === 'string' ? config[fun] : VDT[fun],
          result: false
        }
      }
    } else if (typeof config[fun] === 'function') {
      const tmpR = config[fun](value)
      if (tmpR !== '' && tmpR !== undefined && tmpR !== false) {
        return { msg: tmpR, result: false }
      }
    }
  }

  return { msg: '', result: true }
}
